module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "vue-color__saturation",
    style: ({
      background: _vm.bgColor
    }),
    on: {
      "mousedown": _vm.handleMouseDown
    }
  }, [_c('div', {
    staticClass: "vue-color__saturation--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-color__saturation--black"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-color__saturation--pointer",
    style: ({
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    })
  }, [_c('div', {
    staticClass: "vue-color__saturation--circle"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35e77b08!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Saturation.vue
// module id = 311
// module chunks = 1